<template>
  <div class="header-nav cchea">
    <div class="navleftlogo"><img src="../assets/pchomeimg/logo.png" /></div>
    <div class="nav-center" >
      <div class="nav-center-item" @click="hometo()" :class="backColor">
        {{header_list[0].name}}
      </div>
      <div :class="backColor" class="nav-center-item"  @click.stop="aboutto(1)" @mouseenter="aboutenter()" @mouseleave="aboutleave()">
        <div >{{header_list[1].name}}</div>
    	<div class="abotuhover">
    		<div class="abouthcont" :class="{aboutanizz:true,aboutaniterzz:aboutyi}">
    			<div class="aboutitem" :class="{aboutani:true,aboutaniter:aboutyi}" @click.stop="aboutto(1)">
					<span :class="backColor">{{about}}</span>
				</div>
    			<div class="aboutitem" :class="{aboutani:true,aboutaniter:aboutyi}" @click.stop="aboutto(2)">
					<span :class="backColor">{{around}}</span>
				</div>
    			<div class="aboutitem" :class="{aboutani:true,aboutaniter:aboutyi}" @click.stop="aboutto(3)">
					<span :class="backColor">{{honor}}</span>
				</div>
    			<div class="aboutitem" :class="{aboutani:true,aboutaniter:aboutyi}" @click.stop="aboutto(4)">
					<span :class="backColor">{{news}}</span>
				</div>
    		</div>
    	</div>
      </div>
      <div :class="backColor" class="nav-center-item" @mouseenter="proenter()" @mouseleave="proleave()">
        <div class="navprowh" @click="productto">{{header_list[2].name}}</div>
        <div class="index-hover" :class="{proanizz:true,proaniterzz:proyi}">
          <div class="hover-content" >
            <div class="inhover-hea" :class="{proani:true,proaniter:proyi}">
              <div class="inhoverhea-left">
                <div class="hoverhea-item" v-for="(item,index) in categorylistconts" @click="getProductCateList(item.id)" :class="hovheaitind==item.id?'pronavred':''" v-if="heaproinde==1">
                	{{item.name}}
                </div>
                <div class="hoverhea-item" v-for="(item,index) in categorylistconts" @click="getProductCateList(item.id)" :class="hovheaitind==item.id?'pronavblue':''" v-if="heaproinde==2">
                	{{item.name}}
                </div>
                <div class="hoverhea-item" v-for="(item,index) in categorylistconts" @click="getProductCateList(item.id)" :class="hovheaitind==item.id?'pronavblack':''" v-if="heaproinde==3">
                	{{item.name}}
                </div>
                <div class="hoverhea-item" v-for="(item,index) in categorylistconts" @click="getProductCateList(item.id)" :class="hovheaitind==item.id?'pronavblack':''" v-if="heaproinde==4">
                	{{item.name}}
                </div>
              </div>
              <div class="inhoverhea-right" @click="pronavnumser()">
                <img src="../assets/pchomeimg/hoverxia.png" />
              </div>
            </div>
            <div class="inhover-cent" :class="{proani:true,proaniter:proyi}" id="scroll-x">
              <div class="hovercent-item" v-for="(item, index) in list_img" :key="index" @click="toProduct(item.id)">
                <div class="hovercent-item-img">
                  <img :src="item.menu_image" />
                </div>
                {{item.name}}
              </div>
            </div>
            <div class="inhover-icon" :class="{proani:true,proaniter:proyi}">
              <div class="netx" @click="nextimg()" @mouseenter="playenterli()" @mouseleave="playleaveli()">
                <img v-if="playli" src="../assets/pchomeimg/play.png" />
                <img v-if="!playli" src="../assets/pchomeimg/playne.png" />
              </div>
    		  <div class="hovecentbut" @click="productto">
    			{{heanavall}}
    			<img src="../assets/pchomeimg/morntoproimg.png" />
    			  
    		  </div>
              <div class="pre"@click="preimg()" @mouseenter="playenterri()"  @mouseleave="playleaveri()">
                <img v-if="playri" src="../assets/pchomeimg/play1.png" />
                <img v-if="!playri" src="../assets/pchomeimg/playne1.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="backColor" class="nav-center-item" @click="videoto()" @mouseenter="videoenter()" @mouseleave="videoleave()">
        <div>{{header_list[3].name}}</div>
    	<div class="videouhover">
    		<!-- :class="{videoanizz:true,videoaniterzz:videoyi}" -->
    		<div class="videohcont" :class="{videoanizz:true,videoaniterzz:videoyi}">
    			<div class="videoitem" :class="{videoani:true,videoaniter:videoyi}">
					<span :class="backColor">{{vidtitleo}}</span>
				</div>
    			<div class="videoitem" :class="{videoani:true,videoaniter:videoyi}">
					<span :class="backColor">{{vidtitlet}}</span>
				</div>
    			<div class="videoitem" :class="{videoani:true,videoaniter:videoyi}">
					<span :class="backColor">{{vidtitlew}}</span>
				</div>
    		</div>
    	</div>
      </div>
      <div :class="backColor" class="nav-center-item" @click.stop="queryto(1)" @mouseenter="queryenter()" @mouseleave="queryleave()">
        <div >{{header_list[4].name}}</div>
    	<div class="queryuhover">
    		<div class="queryhcont" :class="{queryanizz:true,queryaniterzz:queryyi}">
    			<div class="queryitem" :class="{queryani:true,queryaniter:queryyi}" @click.stop="queryto(1)">
					<span :class="backColor">{{anticoniden}}</span>
				</div>
    			<div class="queryitem" :class="{queryani:true,queryaniter:queryyi}" @click.stop="queryto(2)">
					<span :class="backColor">{{dadownlo}}</span>
				</div>
    			<div class="queryitem" :class="{queryani:true,queryaniter:queryyi}" @click.stop="queryto(3)">
					<span :class="backColor">{{maintenance}}</span>
				</div>
    			<div class="queryitem" :class="{queryani:true,queryaniter:queryyi}" @click.stop="queryto(4)">
					<span :class="backColor">{{comprob}}</span>
				</div>
    		</div>
    	</div>
      </div>
      <div :class="backColor" class="nav-center-item" @click="elitesto" @mouseenter="eliteenter()" @mouseleave="eliteleave()">
        <div >{{header_list[5].name}}</div>
    	<div class="elitesuhover">
    		<div class="eliteshcont" :class="{eliteanizz:true,eliteaniterzz:eliteyi}">
    			<div class="elitesitem" :class="{eliteani:true,eliteaniter:eliteyi}">
					<span :class="backColor">{{all}}</span>
				</div>
    			<div class="elitesitem" :class="{eliteani:true,eliteaniter:eliteyi}">
					<span :class="backColor">{{society}}</span>
				</div>
    			<div class="elitesitem" :class="{eliteani:true,eliteaniter:eliteyi}">
					<span :class="backColor">{{campus}}</span>
				</div>
    			
    		</div>
    	</div>
      </div>
      <div :class="backColor" class="nav-center-item" @click="contactusto" @mouseenter="contaenter()" @mouseleave="contaleave()">
        <div>{{header_list[6].name}}</div>
    	<div class="contactuhover">
    		<div class="contacthcont" :class="{contaanizz:true,contaaniterzz:contayi}">
    			<div class="contactitem" :class="{contaani:true,contaaniter:contayi}">
					<span :class="backColor">{{heamap}}</span>
				</div>
    			<div class="contactitem" :class="{contaani:true,contaaniter:contayi}">
					<span :class="backColor">{{message}}</span>
				</div>
    			<!-- <div class="contactitem">{{campus}}</div> -->
    		</div>
    	</div>
      </div>
    </div>
    
	<div class="nav-right">
      <div class="search" @click="seachto()">
        <img src="../assets/pchomeimg/sousuo.png" />
      </div>
      <div class="homename" >
        <!-- 啄木鸟官网
				<img src="../assets/pchomeimg/xiala1.png" /> -->
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in channel_list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="language">
        <el-select v-model="valuelang" placeholder="请选择">
          <el-option
            v-for="item in optionslang"
            :key="item.valuelang"
            :label="item.valuelang"
            :value="item.labellang"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
	import 'lib-flexible/flexible.js'
import { session } from "./../storage/storage.js";
export default {
  data() {
    return {
      playli: true,
	  aboutyi:false,
	  proyi:false,
	  videoyi:false,
	  queryyi:false,
	  eliteyi:false,
	  contayi:false,
	  hovheaitind:1,
	  heanavall:'查看全部',
	  about: "关于啄木鸟",
	  around: "公司环境",
	  honor: '公司荣誉',
	  news : '新闻中心',
	  anticoniden:'防伪鉴别',
	  dadownlo:'资料下载',
	  maintenance:'维护保养',
	  comprob:'常见问题',
	  all : "全部",
	  society: "社会招聘",
	  campus: "校园招聘",
	  vidtitleo:'产品介绍',
	  vidtitlet:'案例分析',
	  vidtitlew:'网络课程',
	  heamap:'map',
	  message:'留言',
      playri: true,
	  pronavnums:9,
	  categorylistconts:[],
      lang: session.get("lang"),
      channel_list:[],
      optionslang: [
        {
          valuelang: "中文",
          labellang: "CN",
        },
        {
          valuelang: "EN",
          labellang: "EN",
        },
      ],
      header_list :[
        { id: 1, name: "首页"},
        { id: 2, name: "关于我们"},
        { id: 3, name: "产品中心"},
        { id: 4, name: "视频中心"},
        { id: 5, name: "用户服务"},
        { id: 5, name: "诚聘精英"},
        { id: 5, name: "联系我们"},
      ],
      value: "",
      valuelang: "",
      categorylist: "",
      list_img:""
    };
  },
  created() {
    //请求所有channnel
    this.getIndexData();
    //产品中心
    this.getProductList();
    this.valuelang =
      session.get("lang") == "en"
        ? this.optionslang[1].labellang
        : this.optionslang[0].labellang;
    //默认选中品牌
     this.checkChannel();
  },
  watch: {
    valuelang(new_val, old_val) {
      session.set("lang", new_val.toLowerCase());
      //菜单栏变化
      if (new_val.toLowerCase() === "cn"){
		 this.heanavall="查看全部"
		 this.about= "关于啄木鸟",
		 this.around= "公司环境",
		 this.honor= '公司荣誉',
		 this.news = '新闻中心',
		 
		this.anticoniden='防伪鉴别',
		this.dadownlo='资料下载',
		this.maintenance='维护保养',
		this.comprob='常见问题',
		 
		this.all = "全部",
		this.society= "社会招聘",
		this.campus= "校园招聘",
		this.vidtitleo='产品介绍'
		this.vidtitlet='案例分析'
		this.vidtitlew='网络课程'
		this.heamap='地图'
		this.message='留言'
         this.header_list =  [
			 
            { id: 1, name: "首页"},
            { id: 2, name: "关于我们"},
            { id: 3, name: "产品中心"},
            { id: 4, name: "视频中心"},
            { id: 5, name: "用户服务"},
            { id: 5, name: "诚聘精英"},
            { id: 5, name: "联系我们"},
          ];
      }else{
		  this.heanavall="View all"
		  this.about= "About woodpecker",
		  this.around= "Company environment",
		  this.honor= 'Company honor',
		  this.news = 'News Center',
		  
		  this.anticoniden='Anti counterfeiting identification',
		  this.dadownlo='Data download',
		  this.maintenance='Maintenance',
		  this.comprob='common problem',
		  this.all = "All",
		  this.society= "Social recruitment",
		  this.campus= "Campus Recruitment",
		  this.vidtitleo='Product introduction'
		  this.vidtitlet='Case sharing'
		  this.vidtitlew='Network course'
		  this.heamap='map'
		  this.message='Leaving a message'
          this.header_list =  [
            { id: 1, name: "Index"},
            { id: 2, name: "About"},
            { id: 3, name: "Product"},
            { id: 4, name: "Video"},
            { id: 5, name: "User"},
            { id: 5, name: "Recruiting"},
            { id: 5, name: "Contact"},
          ];
      }

      this.$emit("ChangeEmit"); //1.向外部触发一个事件
      this.getProductList();
      this.getIndexData();

    },
    value(new_val, old_val){
      if (typeof new_val !== 'number' && isNaN(new_val)){
          return;
      }
	  this.heaproinde=new_val
	  if(new_val==1){
	  		  /* this. */
	  		  
	  		  this.backColor="redbacll"
	  }else if(new_val==2){
	  		  this.backColor="bluebacll"
	  }else if(new_val==3){
	  		  this.backColor="blackBack"
	  }else if(new_val==4){
	  		  this.backColor="blackBack"
	  }
      session.set("channel_id",new_val);
      this.$emit("ChangeEmit"); //1.向外部触发一个事件
      this.hometo();
    }
  },
  methods: {
	  contaenter(){
	    this.contayi=true
	  		
	  },
	  contaleave(){
	    this.contayi=false
	  },
	  eliteenter(){
	    this.eliteyi=true
	  		
	  },
	  eliteleave(){
	    this.eliteyi=false
	  },
	  queryenter(){
	    this.queryyi=true
	  		
	  },
	  queryleave(){
	    this.queryyi=false
	  },
	  videoenter(){
	    this.videoyi=true
	  		
	  },
	  videoleave(){
	    this.videoyi=false
	  },
	  proenter(){
	    this.proyi=true
	  		
	  },
	  proleave(){
	    this.proyi=false
	  },
	  aboutenter(){
	    this.aboutyi=true
		
	  },
	  aboutleave(){
	    this.aboutyi=false
	  },
	  pronavnumser(){
		  if(this.pronavnums==this.categorylist.length){
			  this.pronavnums=9
			  this.getProductList()
		  }else{
			  this.pronavnums=this.categorylist.length
			  this.getProductList()
		  }
		  
		  
	  },
    getProductCateList(id){ //根据分类id获取产品
	this.hovheaitind=id
      let data={
        lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
        channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
        page:1,
        pageSize:10,
        category_id:id,
        mold:"pc",
      }
      this.$api.get_channel_category_id_list(data).then((res) => {
        this.list_img=res.data
        // console.info('1',res.data);
      });
    },
    getProductList(){
        let data={
          lang:session.get('lang'),
          channel_id: session.get('channel_id'),
        }
        this.$api.get_channel_category_list(data).then((res) => {
			this.categorylist=res.data
		 
			this.categorylistconts=[]
			for(let l =0;l<this.pronavnums;l++){
				this.categorylistconts.push(this.categorylist[l])
			}
			this.getProductCateList(res.data[0].id)
		  
        });
    },
    checkChannel(){
      let _this = this;
      let channel_id =  session.get('channel_id');
	  this.heaproinde=channel_id
	  if(channel_id==null){
	  	channel_id=1
		session.set("channel_id",channel_id);
	  }
	  if(channel_id==1){
	  		
	  		  this.backColor="redbacll"
	  }else if(channel_id==2){
	  		  this.backColor="bluebacll"
	  }else if(channel_id==3){
	  		  this.backColor="blackBack"
	  }else if(channel_id==4){
	  		  this.backColor="blackBack"
	  }
      _this.channel_list.forEach(function(value,index){
        if (value.id == channel_id){
          _this.value = _this.channel_list[index].name;
        }
      });
    },
    getIndexData() {
      this.$api.pcindex({ mold: "pc",lang:session.get("lang") == '' ? 'cn' : session.get("lang") }).then((res) => {
        this.channel_list = res.data;
        this.checkChannel();

      });
    },
    hometo() {
      this.$router.push({ path: "/pchome" });
    },
    videoto() {
      this.$router.push({ path: "/pcvideos" });
    },
    queryto(e) {
      this.$router.push({ path: "/pcquerys",query:{e} });
    },
    productto() {
      this.$router.push({ path: "/pcproduct" });
    },
    elitesto() {
      this.$router.push({ path: "/pcelites" });
    },
    contactusto() {
      this.$router.push({ path: "/pccontactus" });
    },
    aboutto(e) {
      this.$router.push({ path: "/pcabout",query:{e}});
    },
    seachto() {
      this.$router.push({ path: "/pcseachs" });
    },
    toProduct(e){
		
		this.$router.push({ path: "/pcdetails",query: {e,type:'pc'}});
    },
    nextimg() {
      let l = this.list_img.length;
      let scroll = document.getElementById("scroll-x");
      let diatance = scroll.scrollWidth - scroll.clientWidth;
      if (this.current_index == 0) {
        this.current_index = l - 1;
        scroll.scrollLeft = diatance;
      } else {
        this.current_index--;
        scroll.scrollLeft -= diatance / (l - 1);
      }
    },
    preimg() {
      let l = this.list_img.length;
      let scroll = document.getElementById("scroll-x");
      let diatance = scroll.scrollWidth - scroll.clientWidth;
      if (this.current_index + 1 == l) {
        this.current_index = 0;
        scroll.scrollLeft = 0;
      } else {
        this.current_index++;
        scroll.scrollLeft += diatance / (l - 1);
      }
    },
    enter(index) {
      this.navheader = true;
    },
    playenterli() {
      this.playli = false;
    },

    playenterri() {
      this.playri = false;
    },
    playleaveli() {
      this.playli = true;
    },
    playleaveri() {
      this.playri = true;
    },
    getParams() {
      this.id = this.$route.query.e;
    },
  },
};
</script>
<style scoped>
.header-nav {
  width: 1440px;
  height: 79px;
  display: flex;
  align-items: center;
  padding: 0 240px;
  position: fixed;
  top: 0;
}
.nav-wit {
}
.navleftlogo{
	display: flex;
	top: 0;
	
}
.navleftlogo img {
  width: 100px;
  height: 50px;
}
.navprowh{
	display: flex;
	justify-content: center;
	align-items: center;
	height: 79px;
}
/* .nav-center-item:hover {
  border-bottom: 2px solid #e31e24;
  color: #D03E3D;
} */

.nav-center-item:first-child {
  margin-left: 0;
}
.nav-right {
  min-width: 210px;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  margin-left: 200px;
}
.nav-right .search {
  width: 20px;
  height: 20px;
  margin-right: 20px;
  cursor: pointer;
  display: flex;
}
.nav-right .search img {
  width: 100%;
  height: 100%;
}
.nav-right .homename {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  cursor: pointer;
}
.language .el-input--suffix .el-input__inner {
  padding-right: 0px;
  color: #fff;
  border: none;
}
/* .ffflanguage .el-input__inner {
  color: #fff ;
}
.ffflanguage .el-select .el-input .el-select__caret {
  font-size: 20px;
  color: #fff;
} */
.language .el-input__inner {
  padding: 0px;
  width: 0px;
  width: 60px;
  background-color: transparent;
}
.language .el-select .el-input .el-select__caret {
  font-size: 14px;
  color: #fff;
}
/* .language .el-input{
		font-size: 16px;
		font-weight: bold;
		color: #333333;
		display: flex;
	} */
.nav-right .homename .el-input--suffix .el-input__inner {
  padding-right: 0px;
  border: none;
}

 .homename .el-input__inner {
  padding: 0px;
  width: 0px;
  width: 120px;
  background-color: transparent;
  color: #fff;
}
 .homename .el-input {
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  display: flex;
}
 .homename .el-select .el-input .el-select__caret {
  font-size: 14px;
  color: #fff;
}
.nav-right .homename .el-icon-arrow-up:before {
}
.nav-right .homename .el-input__prefix,
.nav-right .homename .el-input__suffix {
  position: relative;
  font-size: 14px;
  font-weight: 400;
  color: #5d5f5f;
}
.nav-right .homename .el-select {
  width: 100%;
}
.nav-right .homename img {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}
.nav-right .language {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.nav-right .language img {
  width: 16px;
  height: 16px;
  margin-left: 6px;
}
/* .navindex:hover .index-hover{
		display: block;
	}
	.index-hover{
		
		display: none;
		position: absolute;
		width: 100%;
		background: #FFFFFF;
		top: 79px;
		left: 0;
		font-size: 16px;
		font-weight: 400;
		color: #5d5f5f;
		padding-bottom: 40px;
		box-sizing: border-box;
	} */
	.inhover-hea{
		display: flex;
		justify-content: space-between;
	}
	.inhoverhea-left{
		display: flex;
		flex-wrap: wrap;
		margin-left: -24px;
		margin-top: 40px;
		width: 1350px;
	}
	.inhoverhea-right{
		margin-top: 40px;
		width: 20px;
		height: 20px;
	}
	.inhoverhea-right img{
		width: 100%;
		height: 100%;
	}
	.hover-content{
		width: 1440px;
		margin: 0 auto;
	}
	.hoverhea-item{
		margin-left: 24px;
		margin-bottom: 20px;
	}
	.inhover-cent{
		overflow: auto;
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
	}
	.hovercent-item{
		width: 256px;
		text-align: center;
		color: #333;
		font-size: 14px;
		font-weight: 400;
		margin-bottom: 40px;
		margin-left: 40px;
		margin-top: 40px;


	}
	.hovercent-item-img{
		width: 256px;
		height: 256px;
		overflow: hidden;
		border-radius: 20px;
		margin-bottom: 20px;
	}
	.hovercent-item:first-child{
		margin-left: 0;
	}
	.hovercent-item img{
		width: 256px;
		height: 256px;
		transition: all 1s linear;
		
	}
	.hovercent-item img:hover img{
		cursor: pointer;
		
		transform: scale(1.1,1.1); 
	}
	.inhover-icon{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.netx{
		width: 50px;
		height: 50px;
		cursor: pointer;
	}
	.netx img{
		width: 100%;
		height: 100%;
	}
	.pre{
		width: 50px;
		height: 50px;
		margin-left: 24px;
		cursor: pointer;
	}
	.pre img{
		width: 100%;
		height: 100%;
	}
.bb {
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 99;
}
.hovecentbut{
	display: flex;
	justify-content: center;
	align-items: center;
	/* line-height: 30px; */
	margin-left: 25px;
}
.hovecentbut img{
	width: 15px;
	height: 15px;
	margin-left: 10px;
}
.navcc{
	color: #D03E3D;
}
.aboutaniter{
		transform: translateY(0%) !important;
		opacity: 1 !important;
		transition: all 1s ease;
	}
	.aboutani{
		transform: translateY(-100%);
		opacity: 0;
	}
	.aboutaniterzz{
		height: 100px;
		position: absolute;
		top: 79px !important;
		/* background: red !important; */
	}
	.aboutanizz{
		/* position: absolute;
		top: -488px; */
		/* position: absolute;
		width: 100% !important;
		background: red;
		top: -179px; */
		
		background: #FFF;
	}
	.videouhover{
		
		
		/* position: absolute; */
		/* top: -488px; */
	}
	.videohcont{
		display: flex;
		position: absolute;
		width: 100% !important;
		background: #FFF;
		top: -179px;
		left: 0;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		/* height: 100px; */
		align-items: center;
		justify-content: center;
	}
	.proaniter{
		transform: translateY(0%) !important;
		opacity: 1 !important;
		transition: all 1s ease;
	}
	.proani{
		transform: translateY(-10%);
		opacity: 0;
	}
	.proaniterzz{
		
		position: absolute;
		display: block !important;
		top: 79px !important;
		background: #FFFFFF;
		/* background: red !important; */
	}
	.proanizz{
		/* position: absolute;
		top: -488px; */
		/* position: absolute;
		width: 100% !important;
		background: red;
		top: -179px; */
		
		background: #FFF;
	}
	.index-hover{
		display: block !important;
		position: absolute;
		width: 100%;
		background: #FFFFFF;
		top: -999px;
		left: 0;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		padding-bottom: 40px;
		box-sizing: border-box;
	}
	.abouthcont{
		background-color: #fff;
		display: flex;
		position: absolute;
		width: 100%;
		top: -179px;
		left: 0;
		height: 100px;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f !important;
		align-items: center;
		justify-content: center;
		
	}
	.videoaniter{
		transform: translateY(0%) !important;
		opacity: 1 !important;
		transition: all 1s ease;
	}
	.videoani{
		transform: translateY(-100%);
		opacity: 0;
	}
	.videoaniterzz{
		height: 100px;
		position: absolute;
		top: 79px !important;
	}
	.videoanizz{
		background: #FFF;
	}
	.queryhcont{
		display: flex;
		position: absolute;
		width: 100%;
		background: #FFFFFF;
		top: -179px;
		left: 0;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		height: 100px;
		align-items: center;
		justify-content: center;
	}
	.queryaniter{
		transform: translateY(0%) !important;
		opacity: 1 !important;
		transition: all 1s ease;
	}
	.queryani{
		transform: translateY(-100%);
		opacity: 0;
	}
	.queryaniterzz{
		height: 100px;
		position: absolute;
		top: 79px !important;
	}
	.queryanizz{
		background: #FFF;
	}
	.eliteshcont{
		display: flex;
		position: absolute;
		width: 100%;
		background: #FFFFFF;
		top: -179px;
		left: 0;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		height: 100px;
		align-items: center;
		justify-content: center;
	}
	.eliteaniter{
		transform: translateY(0%) !important;
		opacity: 1 !important;
		transition: all 1s ease;
	}
	.eliteani{
		transform: translateY(-100%);
		opacity: 0;
	}
	.eliteaniterzz{
		height: 100px;
		position: absolute;
		top: 79px !important;
	}
	.eliteanizz{
		background: #FFF;
	}
	.contacthcont{
		display: flex;
		position: absolute;
		width: 100%;
		background: #FFFFFF;
		top: -179px;
		left: 0;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		height: 100px;
		align-items: center;
		justify-content: center;
	}
	.contaaniter{
		transform: translateY(0%) !important;
		opacity: 1 !important;
		transition: all 1s ease;
	}
	.contaani{
		transform: translateY(-100%);
		opacity: 0;
	}
	.contaaniterzz{
		height: 100px;
		position: absolute;
		top: 79px !important;
	}
	.contaanizz{
		background: #FFF;
	}
	
	
	.header-nav {
	  width: 1440px;
	  height: 79px;
	  display: flex;
	  align-items: center;
	  padding: 0 240px;
	  position: fixed;
	  top: 0;
	}
	.nav-wit {
	}
	.nav-left {
	  min-width: 100px;
	  height: 50px;
	}
	.nav-left img {
	  width: 100px;
	  height: 50px;
	}
	.navprowh{
		display: flex;
		justify-content: center;
		align-items: center;
		height: 79px;
	}
	/* .nav-center-item:hover {
	  border-bottom: 2px solid #e31e24;
	} */
	
	.nav-center-item:first-child {
	  margin-left: 0;
	}
	.nav-right {
	  min-width: 210px;
	  display: flex;
	  align-items: center;
	  color: #fff;
	  font-size: 14px;
	  font-weight: 400;
	  margin-left: 200px;
	}
	.nav-right .search {
	  width: 20px;
	  height: 20px;
	  margin-right: 20px;
	  cursor: pointer;
	  display: flex;
	}
	.nav-right .search img {
	  width: 100%;
	  height: 100%;
	}
	.nav-right .fffhomename {
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  margin-right: 20px;
	  cursor: pointer;
	}
	.ffflanguage .el-input--suffix .el-input__inner {
	  padding-right: 0px;
	  border: none;
	}
	/* .fffffflanguage .el-input__inner {
	
	}
	.ffflanguage .el-select .el-input .el-select__caret {
	  font-size: 20px;
	
	} */
	.ffflanguage .el-input__inner {
	  padding: 0px;
	  width: 0px;
	  width: 70px;
	  background-color: transparent;
	}
	.ffflanguage .el-select .el-input .el-select__caret {
	  font-size: 14px;
	 color: #666;
	}
	/* .language .el-input{
			font-size: 16px;
			font-weight: bold;
			color: #5d5f5f;
			display: flex;
		} */
	.nav-right .fffhomename .el-input--suffix .el-input__inner {
	  padding-right: 0px;
	  border: none;
	}
	/* .fffhominame .el-input__inner {
	  color: #666;
	}
	.fffhominame .el-select .el-input .el-select__caret {
	  font-size: 20px;
	  color: #666;
	} */
	.nav-right .fffhomename .el-input__inner {
	  padding: 0px;
	  width: 0px;
	  width: 120px;
	  background-color: transparent;
	  color: #666;
	}
	.nav-right .fffhomename .el-input {
	  font-size: 14px;
	  font-weight: bold;
	 
	  display: flex;
	  color: #666;
	}
	 .fffhomename .el-select .el-input .el-select__caret {
	  font-size: 14px;
	  color: #666;
	}
	.nav-right .fffhomename .el-icon-arrow-up:before {
	}
	.nav-right .fffhomename .el-input__prefix,
	.nav-right .fffhomename .el-input__suffix {
	  position: relative;
	  font-size: 14px;
	  font-weight: 400;
	 
	}
	.nav-right .fffhomename .el-select {
	  width: 100%;
	}
	.nav-right .fffhomename img {
	  width: 16px;
	  height: 16px;
	  margin-left: 4px;
	}
	.nav-right .ffflanguage {
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  cursor: pointer;
	}
	.nav-right .ffflanguage img {
	  width: 16px;
	  height: 16px;
	  margin-left: 6px;
	}
	
		/* .index-hover{
			display: block;
			position: absolute;
			width: 100%;
			background: #FFFFFF;
			top: 79px;
			left: 0;
			font-size: 16px;
			font-weight: 400;
			color: #5d5f5f;
			padding-bottom: 40px;
			box-sizing: border-box;
		} */
		.inhover-hea{
			display: flex;
			justify-content: space-between;
		}
		.inhoverhea-left{
			display: flex;
			flex-wrap: wrap;
			margin-left: -24px;
			margin-top: 40px;
			width: 1350px;
		}
		.inhoverhea-right{
			margin-top: 40px;
			width: 20px;
			height: 20px;
		}
		.inhoverhea-right img{
			width: 100%;
			height: 100%;
		}
		.hover-content{
			width: 1440px;
			margin: 0 auto;
		}
		.hoverhea-item{
			margin-left: 24px;
			margin-bottom: 20px;
			color: rgba(0,0,0,.6);
		}
		.inhover-cent{
			overflow: auto;
			display: flex;
			align-items: center;
			flex-wrap: nowrap;
		}
		.hovercent-item{
			width: 256px;
			text-align: center;
			color: #333;
			font-size: 14px;
			font-weight: 400;
			margin-bottom: 40px;
			margin-left: 40px;
			margin-top: 40px;
	
	
		}
		.hovercent-item-img{
			width: 256px;
			height: 256px;
			overflow: hidden;
			border-radius: 20px;
			margin-bottom: 20px;
		}
		.hovercent-item:first-child{
			margin-left: 0;
		}
		.hovercent-item img{
			width: 256px;
			height: 256px;
			transition: all 1s linear;
		}
		.hovercent-item img:hover {
			cursor: pointer;
			transform: scale(1.1,1.1); 
		}
		.inhover-icon{
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.netx{
			width: 50px;
			height: 50px;
			cursor: pointer;
		}
		.netx img{
			width: 100%;
			height: 100%;
		}
		.pre{
			width: 50px;
			height: 50px;
			margin-left: 24px;
			cursor: pointer;
		}
		.pre img{
			width: 100%;
			height: 100%;
		}
	.bb {
	  background-color: #fff;
	  position: fixed;
	  top: 0;
	  z-index: 99;
	}
	.hovecentbut{
		display: flex;
		justify-content: center;
		align-items: center;
		/* line-height: 30px; */
		margin-left: 25px;
	}
	.hovecentbut img{
		width: 15px;
		height: 15px;
		margin-left: 10px;
	}
	.navcc{
		color: #D03E3D;
	}
	
	/* .navabout:hover .aboutitem {
		
	    width: 100%;
		height: 100px;
		margin-top: 79px;
		transform: translateY(0%) !important;
		opacity: 1 !important;
		transition: all .5s ease;
	} */
	.abouthcont{
		background-color: #fff;
		display: flex;
		position: absolute;
		width: 100%;
		top: 79px;
		left: 0;
		height: 100px;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		align-items: center;
		justify-content: center;
		
	}
	.aboutitem{
		
		/* transform: translateY(-30%);
		opacity: 0; */
		margin-left: 100px;
		/* margin-right: 70px; */
	}
	.aboutitem:first-child{
		margin-left: -200px;
	}
	/* .aboutitem:hover{
		color: #D03E3D;
	} */
	.queryhcont{
		display: flex;
		position: absolute;
		width: 100%;
		background: #FFFFFF;
		top: 79px;
		left: 0;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		height: 100px;
		align-items: center;
		justify-content: center;
	}
	.queryitem{
		margin-left: 100px;
		
	}
	.queryitem:first-child{
		margin-left: -200px;
	}
	/* .queryitem:hover{
		color: #D03E3D;
	} */
	.eliteshcont{
		display: flex;
		position: absolute;
		width: 100%;
		background: #FFFFFF;
		top: 79px;
		left: 0;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		height: 100px;
		align-items: center;
		justify-content: center;
	}
	.elitesitem{
		margin-left: 100px;
		
	}
	.elitesitem:first-child{
		margin-left: -200px;
	}
	/* .elitesitem:hover{
		color: #D03E3D;
	} */
	.contacthcont{
		display: flex;
		position: absolute;
		width: 100%;
		background: #FFFFFF;
		top: 79px;
		left: 0;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		height: 100px;
		align-items: center;
		justify-content: center;
	}
	.contactitem{
		margin-left: 100px;
		
	}
	.contactitem:first-child{
		margin-left: -200px;
	}
	/* .contactitem:hover{
		color: #D03E3D;
	} */
	/* .navvideo:hover .videouhover{
		display: block;
	}
	.videouhover{
		display: none;
	} */
	.videohcont{
		display: flex;
		position: absolute;
		width: 100% !important;
		background: #FFFFFF;
		top: 79px;
		left: 0;
		font-size: 14px;
		font-weight: 400;
		color: #5d5f5f;
		/* height: 100px; */
		align-items: center;
		justify-content: center;
	}
	.videoitem{
		margin-left: 100px;
		
	}
	.videoitem:first-child{
		margin-left: -200px;
	}
	/* .videoitem:hover{
		color: #D03E3D;
	} */
	.abouanmin{
			-webkit-animation-name: "drop-down"; /*动画名称，需要跟@keyframes定义的名称一致*/
			-webkit-animation-duration: 2s;/*动画持续的时间长*/
			-webkit-animation-iteration-count: 1;/*动画循环播放的次数为1 infinite为无限次*/
			color: #0000FF;
		}
		.aboutaniter{
			transform: translateY(0%) !important;
			opacity: 1 !important;
			transition: all 1s ease;
		}
		.aboutani{
			transform: translateY(-100%);
			opacity: 0;
		}
		.aboutaniterzz{
			height: 100px;
			position: absolute;
			top: 79px !important;
			/* background: red !important; */
		}
		.aboutanizz{
			/* position: absolute;
			top: -488px; */
			/* position: absolute;
			width: 100% !important;
			background: red;
			top: -179px; */
			
			background: #FFF;
		}
		.videouhover{
			
			
			/* position: absolute; */
			/* top: -488px; */
		}
		.videohcont{
			display: flex;
			position: absolute;
			width: 100% !important;
			background: #FFF;
			top: -179px;
			left: 0;
			font-size: 14px;
			font-weight: 400;
			color: #5d5f5f;
			/* height: 100px; */
			align-items: center;
			justify-content: center;
		}
		.proaniter{
			transform: translateY(0%) !important;
			opacity: 1 !important;
			transition: all 1s ease;
		}
		.proani{
			transform: translateY(-10%);
			opacity: 0;
		}
		.proaniterzz{
			
			position: absolute;
			display: block !important;
			top: 79px !important;
			background: #FFFFFF;
			/* background: red !important; */
		}
		.proanizz{
			/* position: absolute;
			top: -488px; */
			/* position: absolute;
			width: 100% !important;
			background: red;
			top: -179px; */
			
			background: #FFF;
		}
		.index-hover{
			display: block !important;
			position: absolute;
			width: 100%;
			background: #FFFFFF;
			top: -889px;
			left: 0;
			font-size: 14px;
			font-weight: 400;
			color: #5d5f5f;
			padding-bottom: 40px;
			box-sizing: border-box;
		}
		.abouthcont{
			background-color: #fff;
			display: flex;
			position: absolute;
			width: 100%;
			top: -179px;
			left: 0;
			height: 100px;
			font-size: 14px;
			font-weight: 400;
			color: #5d5f5f;
			align-items: center;
			justify-content: center;
			
		}
		.videoaniter{
			transform: translateY(0%) !important;
			opacity: 1 !important;
			transition: all 1s ease;
		}
		.videoani{
			transform: translateY(-100%);
			opacity: 0;
		}
		.videoaniterzz{
			height: 100px;
			position: absolute;
			top: 79px !important;
		}
		.videoanizz{
			background: #FFF;
		}
		.queryhcont{
			display: flex;
			position: absolute;
			width: 100%;
			background: #FFFFFF;
			top: -179px;
			left: 0;
			font-size: 14px;
			font-weight: 400;
			color: #5d5f5f;
			height: 100px;
			align-items: center;
			justify-content: center;
		}
		.queryaniter{
			transform: translateY(0%) !important;
			opacity: 1 !important;
			transition: all 1s ease;
		}
		.queryani{
			transform: translateY(-100%);
			opacity: 0;
		}
		.queryaniterzz{
			height: 100px;
			position: absolute;
			top: 79px !important;
		}
		.queryanizz{
			background: #FFF;
		}
		.eliteshcont{
			display: flex;
			position: absolute;
			width: 100%;
			background: #FFFFFF;
			top: -179px;
			left: 0;
			font-size: 14px;
			font-weight: 400;
			color: #5d5f5f;
			height: 100px;
			align-items: center;
			justify-content: center;
		}
		.eliteaniter{
			transform: translateY(0%) !important;
			opacity: 1 !important;
			transition: all 1s ease;
		}
		.eliteani{
			transform: translateY(-100%);
			opacity: 0;
		}
		.eliteaniterzz{
			height: 100px;
			position: absolute;
			top: 79px !important;
		}
		.eliteanizz{
			background: #FFF;
		}
		.contacthcont{
			display: flex;
			position: absolute;
			width: 100%;
			background: #FFFFFF;
			top: -179px;
			left: 0;
			font-size: 14px;
			font-weight: 400;
			color: #5d5f5f;
			height: 100px;
			align-items: center;
			justify-content: center;
		}
		.contaaniter{
			transform: translateY(0%) !important;
			opacity: 1 !important;
			transition: all 1s ease;
		}
		.contaani{
			transform: translateY(-100%);
			opacity: 0;
		}
		.contaaniterzz{
			height: 100px;
			position: absolute;
			top: 79px !important;
		}
		.contaanizz{
			background: #FFF;
		}
		.cchea{
			position: fixed;
			top: 0;
			z-index: 99;
		}
		.redbacll:hover{
			color: #D03E3D;
		}
		.bluebacll:hover{
			color: #0000FF;
		}
		.blackBack:hover{
			color: #000000;
		}
		.pronavred{
			color: #D03E3D;
		}
		.pronavblue{
			color: #0000FF;
		}
		.pronavblack{
			color: #000000;
		}
</style>
